import React from "react";
import { Label as AriaLabel, type LabelProps } from "react-aria-components";
import { useDefaultLabelStyle } from "../context.tsx";
import { base } from "./Label.css.ts";
import { Tooltip, TooltipIcon } from "./Tooltip.tsx";
import type { OmittedReactAriaProps } from "./types.ts";

export interface Props extends Omit<
  LabelProps,
  OmittedReactAriaProps | "elementType"
> {
  children?: React.ReactNode;
  /** Tooltip text shown when hovering the tooltip icon next to the label. */
  tooltip?: string;
  /** Ref to the underlying label element. */
  ref?: React.Ref<HTMLLabelElement>;
}

/**
 * Text label for form inputs. Supports optional tooltip icon for additional context.
 */
export const Label: React.FC<Props> = ({
  tooltip,
  children,
  ref,
  ...props
}) => {
  const defaultLabelStyle = useDefaultLabelStyle();

  return (
    <AriaLabel ref={ref} {...props} className={base({ defaultLabelStyle })}>
      {children}
      {tooltip != null && tooltip.length > 0 && (
        <Tooltip text={tooltip}>
          <TooltipIcon />
        </Tooltip>
      )}
    </AriaLabel>
  );
};
